import React from 'react';
import { useIntl } from 'react-intl';
import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import SearchBox from '../../../Components/Inputs/SearchBox';
import CustomerMassiveItem from './CustomerMassiveItem';
import { StyledList } from '../../../Theme/StyledComponents';
import { OUTCOME_COLORS, counterChip } from '../Utils/constants';

//sms are identified by activity id, emails by their queue id
export const toRecipient = ({
  id,
  customerName,
  customerSurname,
  message,
  email,
  phoneNumber,
  activityType,
  queueEmailId,
}) => ({
  id: activityType === 'SMS' ? id : queueEmailId,
  fullName: `${customerName ?? ''} ${customerSurname ?? ''}`.trim(),
  contact: activityType === 'SMS' ? phoneNumber : email,
  message,
});

const CustomerListWrapper = function CustomerListWrapper({
  handleSelectCustomer,
  setSearchValues,
  handleChangeCustomersToRemove,
  cleanCustomersToRemove,
  handleRemoveFromBatch,
  ObserverWrapper = null,
  selectedCustomer = null,
  searchValues = null,
  customersToRemove = [],
  recipientsCount = 0,
  messageAlreadySent = false,
}) {
  const intl = useIntl();

  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          p: '12px 16px',
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {intl.messages.RECIPIENTS}
        </Typography>
        {counterChip(recipientsCount, OUTCOME_COLORS.CUSTOMERS)}
        <Box sx={{ ml: 'auto' }}>
          <SearchBox
            setSearchValues={setSearchValues}
            searchValues={searchValues}
            width="180px"
          />
        </Box>
      </Box>
      <Divider />
      <Box sx={{ flexGrow: 1, overflow: 'auto', p: '4px 8px' }}>
        <StyledList dense>
          <ObserverWrapper
            Component={(item) => {
              const recipient = toRecipient(item);
              return (
                <CustomerMassiveItem
                  key={recipient.id}
                  recipient={recipient}
                  onClick={handleSelectCustomer}
                  selected={selectedCustomer === recipient.id}
                  checked={customersToRemove.includes(recipient.id)}
                  onClickCheckbox={handleChangeCustomersToRemove}
                  messageAlreadySent={messageAlreadySent}
                />
              );
            }}
          />
        </StyledList>
      </Box>
      {/* removal toolbar, only while something is selected */}
      {customersToRemove.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            p: '8px 16px',
            borderTop: 1,
            borderColor: 'divider',
          }}
        >
          <Typography variant="body2" sx={{ flexGrow: 1 }}>
            {intl.formatMessage(
              { id: 'SELECTED_ITEMS' },
              { count: customersToRemove.length }
            )}
          </Typography>
          <Tooltip title={intl.messages.CANCEL}>
            <IconButton size="small" onClick={cleanCustomersToRemove}>
              <CloseRoundedIcon />
            </IconButton>
          </Tooltip>
          <Button
            color="error"
            variant="outlined"
            disableElevation
            startIcon={<PersonRemoveIcon />}
            sx={{ textTransform: 'none' }}
            onClick={handleRemoveFromBatch}
          >
            {intl.messages.REMOVE}
          </Button>
        </Box>
      )}
    </Paper>
  );
};

export default CustomerListWrapper;
